import { Typography } from '@mui/material';
import {
  Layout,
  Button,
  resolveButtonShadow,
} from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { ContactZKPD } from './Contact';
import { Faq } from './Faq';
import { Hero } from './Hero';
import {
  StyledZKPDSection,
  StyledContainer,
  StyledTypography,
  StyledSectionTitle,
  StyledCaseStudyArea,
  StyledButtonWrapper,
  StyledLink,
  StyledSectionTitleSmall,
  StyledTypographySmall,
} from './styles';
import { WhyRF } from './WhyRF';
import { WhyUseZKP } from './WhyUseZKP';
import { zeroKnowledgeProofDevelopmentSeo } from './zeroKnowledgeProofDevelopmentPage.seo';
import type { ZeroKnowledgeProofDevelopmentPageProps } from './zeroKnowledgeProofDevelopmentPage.types';
import { ZeroKnowledgeProofDevelopmentServices } from './ZeroKnowledgeProofDevelopmentServices/ZeroKnowledgeProofDevelopmentServices';
import { ZKDevelopmentProcess } from './ZKDevelopmentProcess';
import { OurWork } from './OurWork';

export const ZeroKnowledgeProofDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: ZeroKnowledgeProofDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...zeroKnowledgeProofDevelopmentSeo} />
      <Hero />
      <StyledZKPDSection>
        <StyledContainer>
          <StyledSectionTitle>16 hours to 3 minutes.</StyledSectionTitle>
          <StyledTypography>
            That's how much we reduced ZK-proof processing time for Original
            Works using RISC Zero and Rust. While others are still talking about
            possibilities, we're shipping production-ready zero-knowledge
            solutions that solve real problems for real businesses.
          </StyledTypography>
        </StyledContainer>
        <StyledCaseStudyArea>
          <StyledButtonWrapper>
            <StyledLink
              to="https://www.rumblefish.dev/case-studies/decentralized-ddex-registry-original-works/"
              target="_blank">
              <Button
                sx={{
                  '.MuiStack-root': {
                    backgroundColor: 'transparent !important',
                    border: '1px solid white',
                    boxShadow: (theme) => resolveButtonShadow('teal', theme),
                  },
                }}>
                Read the case study
              </Button>
            </StyledLink>
          </StyledButtonWrapper>
        </StyledCaseStudyArea>
      </StyledZKPDSection>
      <ZeroKnowledgeProofDevelopmentServices />
      <WhyRF />
      <WhyUseZKP />
      <ZKDevelopmentProcess />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <ContactZKPD />
      <StyledContainer>
        <StyledSectionTitleSmall>
          Zero-knowledge proofs are complex. Working with us is not.
        </StyledSectionTitleSmall>
        <StyledTypographySmall>
          <Typography component="span" sx={{ fontWeight: '600' }}>
            Rumble Fish
          </Typography>
          <Typography component="span">
            &nbsp;- Expert zero-knowledge proof development services
          </Typography>
        </StyledTypographySmall>
      </StyledContainer>
    </Layout>
  );
};
